import Index from '@/views/Index/index';
import Detail from '@/views/Detail/index';
export default {
    routes: [{
        path: '/',
        name: '/',
        component: Index
    },{
        path: '/detail',
        name: '/detail',
        component: Detail
    }]
}